import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useContext, useEffect } from 'react';
import UserVehicleContext from '~/context/vdp/UserVehicleContext';

export default function useAddMetaAttributes() {
  const { vehicleAvailability, vehiclePricingInfo } =
    useContext(UserVehicleContext);
  const { updateMetaAttributes } = useContext(AnalyticsContext);

  useEffect(() => {
    if (!vehicleAvailability.isLoaded) return;
    const { action, error, lockType } = vehicleAvailability.data;
    updateMetaAttributes({ availabilityData: { action, error, lockType } });
  }, [
    vehicleAvailability.isLoaded,
    vehicleAvailability.data,
    updateMetaAttributes
  ]);

  useEffect(() => {
    if (!vehiclePricingInfo.isLoaded) return;
    const financingType = vehiclePricingInfo.data?.financeInfo?.financingType;
    if (financingType !== undefined) {
      updateMetaAttributes({ financingType });
    }
  }, [
    vehiclePricingInfo.isLoaded,
    vehiclePricingInfo.data,
    updateMetaAttributes
  ]);

  useEffect(() => {
    return () => {
      updateMetaAttributes({
        availabilityData: undefined,
        financingType: undefined
      });
    };
  }, [updateMetaAttributes]);
}
